import { RaceFinishedCallout } from './RaceFinishedCallout';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { prepareRaceGame, selectHasRaceStarted, startRaceGame } from '../../store/gameStore';
import { BigAppleOptions } from '../../game-engine/maps-utils/big-apple';
import { isGameFinished, isGameInProgress, isStartGame } from '../../constants/game-state';
import { MapOrderById } from '../../game-engine/maps-utils/map-order';
import { MapsTemp } from '../../game-engine/maps-utils/map-functions-temp';
import { enableGameEngine } from '../../game-engine/game_new_sprites';
import { MapOptions } from '../../constants/maps';

export interface IRaceShellProps {
  onClickReloadMenu: () => void;
  raceLobbyProps: any;
  isGrandPrix?: boolean;
}

export const RaceShell = (props: IRaceShellProps) => {
  const dispatch = useDispatch();
  const lobbyProps = props.raceLobbyProps;
  const isGrandPrix = props?.isGrandPrix;
  console.log(props.isGrandPrix);
  const customLobby = !!lobbyProps;
  let optionsCustomMap: any = null;
  if (isGrandPrix === true) {
    console.log(isGrandPrix);
    optionsCustomMap = Object.assign(
      {},
      MapOptions['miamiBeach'],
      { totalCars: 250 },
      {
        road: [
          '66',
          '94',
          '54',
          '14',
          '21',
          '105',
          '54',
          '23',
          '10',
          '14',
          '42',
          '86',
          '37',
          '40',
          '87',
          '83',
          '74',
          '27',
          '102',
          '84',
          '37',
          '50',
          '101',
          '36',
          '41',
          '81',
          '70',
          '27',
          '53',
          '86',
          '72',
          '60',
          '93',
          '95',
          '84',
          '63',
          '77',
          '107',
          '81',
          '21',
          '90',
          '91',
          '54',
          '40',
          '32',
          '14',
          '23',
          '42',
          '85',
          '105',
        ],
      },
      { idLobby: -1 },
      { isGrandPrix: true }
    );
  } else if (customLobby) {
    optionsCustomMap = Object.assign(
      {},
      MapOptions[lobbyProps.map as MapsTemp],
      { totalCars: lobbyProps.cars },
      { road: lobbyProps.road },
      { idLobby: lobbyProps.idLobby }
    );
  }

  // TODO Remove multiple initialization
  // console.log('Initialize RaceShell');

  useEffect(() => {
    dispatch(customLobby || isGrandPrix ? prepareRaceGame(optionsCustomMap) : prepareRaceGame(BigAppleOptions));
  }, []);

  const raceStatus = useSelector(selectHasRaceStarted);
  let raceNumber = 1;
  if (isStartGame(raceStatus)) {
    raceNumber = MapOrderById[raceStatus.gameOptions.id as MapsTemp] + 1;
    dispatch(startRaceGame(raceStatus.gameOptions));
    enableGameEngine(raceStatus.gameOptions);
  }
  if (isGameInProgress(raceStatus)) {
    raceNumber = MapOrderById[raceStatus.gameOptions.id as MapsTemp] + 1;
  }
  if (isGameFinished(raceStatus)) {
    raceNumber = MapOrderById[raceStatus.currentMapId as MapsTemp] + 1;
  }

  const { onClickReloadMenu } = props;

  return (
    <div className="race-shell">
      <div className="bg">
        <div className="brick-block-1">
          <div className="brick-1"></div>
          <div className="brick-2"></div>
        </div>
        <div className="brick-block-2">
          <div className="brick-1"></div>
          <div className="brick-2"></div>
          <div className="brick-3"></div>
        </div>
      </div>
      <div className="arcade-container">
        <div className="arcade-wall">
          <div className="detail detail-1"></div>
          <div className="detail detail-2"></div>
          <div className="top">
            <div className="block-1"></div>
            <div className="block-2"></div>
            <div className="block-3"></div>
            <div className="block-4"></div>
            <div className="block-5"></div>
            <div className="block-6"></div>
            <div className="block-7"></div>
          </div>
        </div>
        <div className="arcade-mid">
          <div className="top">
            <div className="b1-cont">
              <div className="border left" id="border-left-arcade"></div>
              <div className="block-1"></div>
              <div className="border right"></div>
            </div>
            <div className="block-2">
              <a></a>
            </div>
          </div>
          <div className="screen">
            <div id="racer">
              <div id="hud">
                <span id="current_lap_time" className="hud">
                  {' '}
                  <span id="current_lap_time_value" className="value">
                    0.0
                  </span>
                </span>
              </div>
              <div id="speed_hub">
                <span id="speed" className="hud">
                  <span id="speed_value" className="value">
                    0
                  </span>{' '}
                  <br />
                  mph
                </span>
              </div>
              <div id="play_again">
                <span id="menuHud" className="hud">
                  <span id="menu" className="value" onClick={onClickReloadMenu}>
                    To Menu
                  </span>
                </span>
              </div>
              <div id="start" style={{ textAlign: 'center' }}>
                <p style={{ marginBottom: '0.2rem' }}>
                  Timer start after crossing the line. <br /> Use <b>WASD</b> or the <b>Arrow Keys</b> to drive the car{' '}
                </p>
              </div>
              <div id="start_race_info">
                {isGrandPrix ? (
                  <h1 style={{ fontSize: '40px' }}>Bitcoin Degens Grand Prix</h1>
                ) : customLobby ? (
                  <h1 style={{ fontSize: '40px' }}>
                    LOBBY #{lobbyProps.idLobby}: {lobbyProps.map}
                  </h1>
                ) : (
                  <h1 style={{ fontSize: '40px' }}>MAP {raceNumber}.</h1>
                )}
              </div>
              <RaceFinishedCallout optionsCustomMap={optionsCustomMap} />
              <canvas id="canvas">
                Sorry, this example cannot be run because your browser does not support the &lt;canvas&gt; element
              </canvas>
            </div>
          </div>
          <div className="mid">
            <div className="block-1">
              <div className="button yellow"></div>
              <div className="button red"></div>
              <div className="button purple"></div>
            </div>
            <div className="block-2">
              <div id="instructions">
                <p>
                  Use <b>WASD</b> or the <b>Arrow Keys</b> to drive the car
                </p>
              </div>
              <div className="speakers"></div>
              <div className="coins"></div>
            </div>
            <div className="block-3"></div>
          </div>
          <div className="bottom">
            <div className="block-1">
              <div className="box-1">
                <div className="box-2"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="arcade-wall alt">
          <div className="top">
            <div className="block-1"></div>
            <div className="block-2"></div>
            <div className="block-3"></div>
            <div className="block-4"></div>
            <div className="block-5"></div>
            <div className="block-6"></div>
            <div className="block-7"></div>
          </div>
        </div>
      </div>
      <div className="extra">
        <div className="plug"></div>
        <div className="wire"></div>
        <div className="drink"></div>
      </div>
      <div className="ground"></div>
    </div>
  );
};
